export default "__VITE_ASSET__9w5wddxm__"